import { render, staticRenderFns } from "./normalstaff.vue?vue&type=template&id=6c7a6462&scoped=true"
import script from "./normalstaff.vue?vue&type=script&lang=js"
export * from "./normalstaff.vue?vue&type=script&lang=js"
import style0 from "./normalstaff.vue?vue&type=style&index=0&id=6c7a6462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a6462",
  null
  
)

export default component.exports